export default {
  brand: 'CSSBuy Spreadsheet',
  home: 'Início',
  article: 'Guia',
  language: 'Idioma',
  exploreSpreadsheet: 'Explorar CSSBuy Spreadsheet',
  buyItNow: 'Comprar Agora',
  categories: 'Categorias',
  selectCategory: 'Selecione uma categoria',
  allCategories: 'Todas as Categorias',
  popularCategories: 'Categorias Populares',
  latestGuide: 'Guia Mais Recente',
  readGuide: 'Ler Guia Completo',
  backToHome: 'Voltar ao Início',
  shoppingGuide: 'Guia de Compras',
  products: 'Produtos',
  productsTitle: 'Catálogo de Produtos',
  productsSubtitle: 'Explore nossa coleção curada de mais de 100 produtos das melhores marcas. Clique para comprar em nossa loja principal.',
  allProducts: 'Todos os Produtos',
  featuredProducts: 'Produtos em Destaque',
  viewAllProducts: 'Ver Todos os Produtos',
  ctaReady: 'Pronto para comprar?',
  ctaText: 'Visite nossa loja principal para o catálogo completo e as últimas novidades.',
  visitStore: 'Visitar Loja Principal',
  pillarTitle: 'Artigos Fundamentais',
  pillarSubtitle: 'Guias completos para aprofundar seu conhecimento',
  articleLinkHomePrompt: 'Explore mais guias e recursos na nossa página inicial.',
  'footer.description': 'CSSBuy Spreadsheet é um recurso independente para ajudar compradores a pesquisar produtos, comparar opções e encontrar informações úteis antes de fazer um pedido.',
  'footer.links': 'Links Rápidos',
  'footer.resources': 'Recursos',
  'footer.contact': 'Contato',
  'footer.privacy': 'Privacidade',
  'footer.terms': 'Termos',
  'footer.disclaimer': 'Aviso Legal',
  'footer.copyright': '© 2026 cssbuybr.work. Todos os direitos reservados.',
  safetyDisclaimer: 'Este site é um recurso informativo independente. Sempre verifique as informações atuais antes de fazer uma compra.',
  heroEyebrow: 'CSSBuy Spreadsheet Resource',
  heroTitle: 'CSSBuy Spreadsheet — Guias, Listas e Recursos',
  heroDescription: 'Encontre e explore CSSBuy Spreadsheet, listas de produtos, guias de pesquisa, informações de QC, armazém, frete, cupons e dicas de segurança antes de fazer seu pedido.',
  ctaExplore: 'Explorar CSSBuy Spreadsheet',
  ctaGuide: 'Ver Guia do CSSBuy',
  trustLine: 'Guias práticos • Conteúdo atualizado • Português, English e Deutsch',
  spreadsheetTitle: 'CSSBuy Spreadsheet: encontre produtos com mais facilidade',
  spreadsheetDesc: 'O CSSBuy Spreadsheet ajuda a organizar pesquisas de produtos, comparar opções e encontrar informações importantes antes de comprar. Aqui você encontra guias, listas, dicas e recursos para pesquisar com mais eficiência. Sempre confira as informações atuais antes de fazer um pedido.',
  spreadsheetCta: 'Explorar o Spreadsheet',
  whatIsTitle: 'O que é um CSSBuy Spreadsheet?',
  whatIsDesc: 'Um CSSBuy Spreadsheet é uma ferramenta organizada que lista produtos, links, categorias, vendedores e informações de pesquisa. Ele permite que você verifique detalhes, compare opções e tome decisões mais informadas antes de comprar. A ferramenta é útil para quem deseja pesquisar produtos de forma estruturada e encontrar as melhores opções disponíveis.',
  guidesTitle: 'Guias CSSBuy para iniciantes',
  guideCard1: 'Como usar CSSBuy Spreadsheet',
  guideCard2: 'CSSBuy Review',
  guideCard3: 'CSSBuy Shipping Cost',
  guideCard4: 'CSSBuy Warehouse',
  guideCard5: 'CSSBuy QC',
  guideCard6: 'CSSBuy Safety',
  reviewTitle: 'CSSBuy Review: o que você deve verificar antes de usar',
  reviewAspect1: 'Plataforma',
  reviewAspect1Desc: 'Recursos e funcionamento',
  reviewAspect2: 'Produtos',
  reviewAspect2Desc: 'Informações e links',
  reviewAspect3: 'Vendedores',
  reviewAspect3Desc: 'Histórico e sinais de confiança',
  reviewAspect4: 'QC',
  reviewAspect4Desc: 'Fotos e possíveis problemas',
  reviewAspect5: 'Frete',
  reviewAspect5Desc: 'Método, peso e destino',
  reviewAspect6: 'Custos',
  reviewAspect6Desc: 'Taxas e serviços',
  reviewAspect7: 'Segurança',
  reviewAspect7Desc: 'Conta e pagamento',
  reviewCta: 'Ler CSSBuy Review',
  shippingTitle: 'CSSBuy Shipping Cost: quanto custa enviar?',
  shippingDesc: 'O custo de envio pode variar dependendo do peso, dimensões, destino, método de envio, seguro e serviços adicionais. Sempre consulte as informações mais recentes para obter uma estimativa precisa do custo total de envio.',
  shippingCta: 'Ver Guia de Shipping Cost',
  couponTitle: 'CSSBuy Coupon & Discount Code',
  couponDesc: 'Encontre cupons e códigos de desconto verificados para CSSBuy. Sempre verifique a validade atual das ofertas antes de usar.',
  couponCta: 'Ver Cupons e Descontos',
  safetyTitle: 'CSSBuy é seguro? Entenda antes de comprar',
  safetyCard1: 'Conta',
  safetyCard2: 'Pagamento',
  safetyCard3: 'Links',
  safetyCard4: 'Vendedores',
  safetyCard5: 'QC',
  safetyCard6: 'Frete',
  safetyCard7: 'Golpes',
  safetyCta: 'Visitar CSSBuy Safety Center',
  comparisonTitle: 'CSSBuy vs outras plataformas',
  comparisonFeature1: 'Product Research',
  comparisonFeature2: 'Spreadsheet',
  comparisonFeature3: 'QC',
  comparisonFeature4: 'Warehouse',
  comparisonFeature5: 'Shipping',
  comparisonPlatform1: 'CSSBuy',
  comparisonPlatform2: 'Superbuy',
  comparisonPlatform3: 'Sugargoo',
  comparisonPlatform4: 'AllChinaBuy',
  comparisonVerify: 'Verificar',
  finalCtaTitle: 'Pronto para continuar sua pesquisa?',
  finalCtaDesc: 'Explore nossos guias e recursos CSSBuy para comparar informações, entender custos e tomar decisões mais informadas.',
  finalCtaBtn1: 'Explorar CSSBuy Spreadsheet',
  finalCtaBtn2: 'Visitar o Site Principal',
  articleTitle: 'CSSBuy Spreadsheet 2026: Guia Completo para Encontrar Produtos',
  articleMetaDesc: 'Guia completo sobre CSSBuy Spreadsheet. Aprenda como usar, encontrar produtos, verificar vendedores, entender custos de envio e tomar decisões seguras de compra.',
  readingTime: '8 min de leitura',
  published: 'Publicado em 26 de agosto de 2026',
  updated: 'Atualizado em 26 de agosto de 2026',
  author: 'CSSBuyBR Team',
  articleIntro: 'O CSSBuy Spreadsheet tornou-se uma ferramenta essencial para quem deseja pesquisar produtos de forma organizada e eficiente. Neste guia completo, você vai aprender tudo sobre como usar o CSSBuy Spreadsheet para encontrar os melhores produtos, verificar vendedores confiáveis e entender todos os custos envolvidos no processo de compra.',
  articleH2What: 'O que é o CSSBuy Spreadsheet?',
  articlePWhat: 'O CSSBuy Spreadsheet é um recurso organizado que reúne listas de produtos, links de vendedores, categorias e informações de pesquisa. Ele funciona como um catálogo estruturado onde você pode navegar por diferentes categorias de produtos, desde sneakers e roupas até acessórios e eletrônicos. A principal vantagem é ter todas as informações centralizadas em um só lugar, facilitando a comparação entre opções e a verificação de detalhes importantes antes de fazer um pedido.',
  articleH2How: 'Como Usar o CSSBuy Spreadsheet',
  articlePHow: 'Para usar o CSSBuy Spreadsheet de forma eficaz, comece selecionando a categoria de produto que você está procurando. Cada categoria contém listas organizadas com links diretos para os produtos. Antes de clicar em qualquer link, verifique as informações do vendedor, analise as fotos de QC disponíveis e leia as observações sobre o produto. Sempre compare pelo menos três opções antes de tomar uma decisão final.',
  articleH2Categories: 'Categorias Principais do CSSBuy Spreadsheet',
  articlePCategories: 'O CSSBuy Spreadsheet é organizado em categorias que facilitam a navegação. As principais categorias incluem: Sneakers e Shoes, Hoodies e Sweaters, T-Shirts, Jackets, Pants e Shorts, Headwear, Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes e Other Stuff. Cada categoria é mantida atualizada com novos produtos e vendedores regularmente.',
  articleH2Qc: 'Entendendo o QC no CSSBuy',
  articlePQc: 'QC (Quality Control) é um dos aspectos mais importantes ao usar o CSSBuy Spreadsheet. As fotos de QC permitem que você verifique a qualidade do produto antes que ele seja enviado para o seu endereço. Sempre solicite fotos detalhadas e verifique se o produto corresponde à descrição e às fotos originais do vendedor.',
  articleH2Shipping: 'Custos de Envio e Frete',
  articlePShipping: 'Os custos de envio do CSSBuy variam conforme o peso do pacote, as dimensões, o destino final, o método de envio escolhido e serviços adicionais como seguro ou embalagem especial. É fundamental calcular todos esses custos antes de finalizar uma compra para evitar surpresas. Considere também a opção de consolidação de pacotes para economizar no frete.',
  articleH2Safety: 'Dicas de Segurança para Comprar',
  articlePSafety: 'Antes de fazer qualquer compra pelo CSSBuy, verifique sempre o link do produto, confirme a reputação do vendedor, analise as fotos de QC com atenção, verifique o destino do pagamento, confirme as condições de envio e calcule o custo final completo. Nunca compartilhe informações de login e use senhas fortes para proteger sua conta.',
  articleH2Faq: 'Perguntas Frequentes',
  faqQ1: 'O CSSBuy Spreadsheet é gratuito?',
  faqA1: 'Sim, o CSSBuy Spreadsheet é um recurso gratuito para pesquisa de produtos. No entanto, os produtos listados têm custos próprios definidos pelos vendedores.',
  faqQ2: 'Como verificar se um vendedor é confiável?',
  faqA2: 'Verifique o histórico do vendedor, leia avaliações de outros compradores, analise as fotos de QC e confirme se os links dos produtos estão ativos e correspondem às descrições.',
  faqQ3: 'Quanto tempo leva o envio do CSSBuy?',
  faqA3: 'O tempo de envio depende do método escolhido e do destino. Métodos mais rápidos geralmente custam mais, enquanto opções econômicas podem levar mais tempo.',
  faqQ4: 'Posso confiar nas fotos de QC?',
  faqA4: 'As fotos de QC são uma ferramenta valiosa, mas sempre compare com as fotos originais do produto e verifique detalhes como materiais, costuras e acabamentos.',
  articleH2Conclusion: 'Conclusão',
  articlePConclusion: 'O CSSBuy Spreadsheet é uma ferramenta poderosa para quem deseja pesquisar produtos de forma organizada. Ao seguir as dicas deste guia — verificar vendedores, analisar QC, calcular custos de envio e seguir as práticas de segurança — você pode tomar decisões de compra mais informadas e seguras. Continue explorando nossos guias e recursos para aprofundar seu conhecimento.',
  relatedTitle: 'Artigos Relacionados',
  relatedArticle1: 'CSSBuy Review 2026: Features, Shipping, Safety & Pros and Cons',
  relatedArticle2: 'Is CSSBuy Legit? What Beginners Should Know',
  relatedArticle3: 'CSSBuy Shipping Cost: What Determines the Final Price?',
};